import { render, staticRenderFns } from "./SecaoPersonalizadaExpansionPanelHeader.vue?vue&type=template&id=41b9cf24&"
import script from "./SecaoPersonalizadaExpansionPanelHeader.vue?vue&type=script&lang=js&"
export * from "./SecaoPersonalizadaExpansionPanelHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpansionPanelHeader,VIcon})
